/** Dedicated Fitness instructors. Never changes the user's personal avatar. */
export type FitnessInstructorId = 'male' | 'female';

export interface FitnessInstructor {
  readonly id: FitnessInstructorId;
  readonly labelKey: 'fitness.instructor.male' | 'fitness.instructor.female';
  readonly modelUrl: string;
  readonly rigVersion: 'vyv-fitness-mp73-v1';
  /** Immutable approved appearance; URLs change when the authored model changes. */
  readonly appearanceVersion: 'v14';
  readonly accentColor: number;
  readonly framingPaddingM: number;
  /** Scale actor and equipment together, keeping authored contacts aligned. */
  readonly worldScale: number;
}

export const DEFAULT_FITNESS_INSTRUCTOR_ID: FitnessInstructorId = 'male';

export const FITNESS_INSTRUCTORS: readonly FitnessInstructor[] = [
  { id: 'male', labelKey: 'fitness.instructor.male', modelUrl: '/fitness/instructors/v14/male-sport.glb', rigVersion: 'vyv-fitness-mp73-v1', appearanceVersion: 'v14', accentColor: 0x23899b, framingPaddingM: 0.06, worldScale: 1 },
  { id: 'female', labelKey: 'fitness.instructor.female', modelUrl: '/fitness/instructors/v14/female-sport.glb', rigVersion: 'vyv-fitness-mp73-v1', appearanceVersion: 'v14', accentColor: 0x7464be, framingPaddingM: 0.06, worldScale: 0.94 },
];

export function isFitnessInstructorId(value: unknown): value is FitnessInstructorId {
  return value === 'male' || value === 'female';
}

export function getFitnessInstructor(value: unknown = DEFAULT_FITNESS_INSTRUCTOR_ID): FitnessInstructor {
  return FITNESS_INSTRUCTORS.find(instructor => instructor.id === value) ?? FITNESS_INSTRUCTORS[0];
}
